/**
 * Blog listing behavior (sections/main-guides.liquid, sections/main-recipes.liquid) - D-22.
 *
 * Live ships two pieces of JS for these surfaces; both are reproduced here:
 *
 * 1. An identical inline "show more" <script> in both blog sections
 *    (document-wide DOMContentLoaded wiring). Moved into this asset per the
 *    build's asset-JS rule; the logic is live's line for line. The button
 *    labels were Liquid-interpolated section settings in live's inline
 *    script - they now travel via data attributes on .show-btn-container
 *    (data-show-more-label / data-show-less-label), the same house pattern
 *    as collection-listing. Like live, "show more" only REVEALS
 *    already-rendered grid items (.hidden-article) batch by batch - there is
 *    no ajax fetch; once everything is visible the button flips to the
 *    "show less" label and the next click collapses back to the initial
 *    count. Optional auto-load: an IntersectionObserver on the button
 *    container reveals the next batch with live's 300ms loader pulse and
 *    stops observing when nothing is left to reveal.
 *
 * 2. The custom element registration for the recipes hub. Live's legacy
 *    bundle registers the prefixed element name with an EMPTY class body
 *    (constructor only - no methods, no lifecycle callbacks); the element
 *    exists purely as a styling/markup hook. Reproduced verbatim under the
 *    renamed tag. The guides hub's element tag was never registered on live
 *    and stays unregistered here too.
 *
 * The recipes filter-modal script is NOT here: it embeds per-article tag
 * data through a Liquid paginate loop, so it stays inline in
 * sections/main-recipes.liquid (documented there).
 */

(function () {
  'use strict';

  function initBlogShowMore() {
    const showMoreButtons = document.querySelectorAll('.show-btn-button');

    function labelsFor(button) {
      const container = button.closest('.show-btn-container');
      return {
        more: (container && container.getAttribute('data-show-more-label')) || 'Mehr anzeigen',
        less: (container && container.getAttribute('data-show-less-label')) || 'Weniger anzeigen',
      };
    }

    function showMoreArticles(button) {
      const targetId = button.getAttribute('data-target');
      const articlesGrid = document.getElementById(targetId);
      if (!articlesGrid) return false;

      const labels = labelsFor(button);
      const hiddenArticles = Array.from(articlesGrid.querySelectorAll('.hidden-article'));
      const initialCount = parseInt(articlesGrid.getAttribute('data-initial-count')) || 8;
      const articlesPerShowMore = parseInt(articlesGrid.getAttribute('data-articles-per-show-more')) || 8;
      const allArticles = Array.from(articlesGrid.querySelectorAll('.grid__item:not(.grid__item-extra)'));

      if (hiddenArticles.length > 0) {
        const articlesToShow = hiddenArticles.slice(0, articlesPerShowMore);
        articlesToShow.forEach((article) => {
          article.classList.remove('hidden-article');
        });

        const remainingHidden = articlesGrid.querySelectorAll('.hidden-article').length;
        if (remainingHidden === 0) {
          button.textContent = labels.less;
          return false;
        } else {
          button.textContent = labels.more;
          return true;
        }
      } else {
        allArticles.forEach((article, index) => {
          if (index >= initialCount) {
            article.classList.add('hidden-article');
          }
        });
        button.textContent = labels.more;
        button.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        return false;
      }
    }

    showMoreButtons.forEach((button) => {
      button.addEventListener('click', function () {
        showMoreArticles(this);
      });
    });

    const buttonContainers = document.querySelectorAll('.show-btn-container[data-auto-load="true"]');

    if (buttonContainers.length > 0 && 'IntersectionObserver' in window) {
      const observerOptions = {
        root: null,
        rootMargin: '100px',
        threshold: 0.1,
      };

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const container = entry.target;
            const button = container.querySelector('.show-btn-button');
            const loader = container.querySelector('.show-btn-loader');

            if (button) {
              if (loader) {
                loader.style.display = 'flex';
                button.classList.add('loading');
              }

              setTimeout(() => {
                const hasMoreArticles = showMoreArticles(button);

                if (loader) {
                  loader.style.display = 'none';
                  button.classList.remove('loading');
                }

                if (!hasMoreArticles) {
                  observer.unobserve(container);
                }
              }, 300);
            }
          }
        });
      }, observerOptions);

      buttonContainers.forEach((container) => {
        observer.observe(container);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogShowMore);
  } else {
    initBlogShowMore();
  }

  /* Live registers the recipes-hub element with an empty class body - a
     markup/styling hook only. Kept empty on purpose (renamed). */
  if (!customElements.get('main-recipes')) {
    customElements.define('main-recipes', class MainRecipes extends HTMLElement {});
  }
})();
